/**
 * Allowlist of runtime_config keys editable via the dashboard
 * (PATCH /api/v1/admin/config/:key, PR seccion 6.1, AGENT.md decisions
 * 21-22). Only keys listed here may ever be written to the runtime_config
 * table; anything else is rejected before it reaches packages/db.
 *
 * No Zod dependency here on purpose: @mc/types stays a plain-data package
 * (same reasoning as PASSWORD_POLICY_RULES in passwordPolicy.ts). Each
 * entry carries a `validate` predicate plus a human-readable
 * `invalidMessage`, which the Gateway wraps into a Zod `.refine()` (or any
 * other validation layer) rather than this package depending on Zod
 * itself. Consumers that hot-reload a given key (via NatsConfigSource)
 * should treat an invalid incoming value as "keep the previous value",
 * never crash: see IConfigSource.watch and configLoader's
 * onValidationError fail-safe.
 */
const isBoolean = (value) => typeof value === "boolean";
const isPositiveInteger = (value) => typeof value === "number" && Number.isInteger(value) && value > 0;
export const RUNTIME_CONFIG_KEYS = [
    {
        key: "EXCLUSIVE_MODE",
        description: "Whether server-manager rejects starting a server while another is already running (see ServerService.startExclusive, TODO.md Fase 8).",
        validate: isBoolean,
        invalidMessage: "EXCLUSIVE_MODE must be a boolean",
    },
    {
        key: "HEALTH_CHECK_INTERVAL_MS",
        description: "Polling interval for HealthCheckService's GET /api/v2/crafty/check loop.",
        validate: isPositiveInteger,
        invalidMessage: "HEALTH_CHECK_INTERVAL_MS must be a positive integer",
    },
    {
        key: "FALLBACK_FAILURE_THRESHOLD",
        description: "Consecutive Vercel poll failures network-manager tolerates before activating the tunnel fallback route.",
        validate: isPositiveInteger,
        invalidMessage: "FALLBACK_FAILURE_THRESHOLD must be a positive integer",
    },
];
const RUNTIME_CONFIG_KEY_SET = new Set(RUNTIME_CONFIG_KEYS.map((entry) => entry.key));
export function isAllowedRuntimeConfigKey(key) {
    return RUNTIME_CONFIG_KEY_SET.has(key);
}
export function getRuntimeConfigKeyDefinition(key) {
    return RUNTIME_CONFIG_KEYS.find((entry) => entry.key === key);
}
//# sourceMappingURL=runtimeConfigAllowlist.js.map